import React, { useCallback, useEffect, useState } from "react";
import { find, get } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { setMenuMappedList } from "redux/entitlement/actions";
import MyToolMenu from "components/atoms/MyToolMenu";
import { useLocation } from "react-router-dom";
import LeftMenuLinks from "components/pages/myASTM/LeftMenu";
import { ComponentUrls } from "models/navigation.models";
import { printRenewalInvoiceMenu } from "helpers/utilCommon";
import NavigationLogo from "./components/NavigationLogo";
import MenuItems from "./components/MenuItems";
import { MENU_TITLES, PAGE_URL } from "models/common.models";

const MemberMobileMenu = () => {
  const [open, setOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(0);
  const [isRenew, setIsRenew] = useState();
  const [customMenu, setCustomMenu] = useState([]);
  const location = useLocation();
  const { entitlement, user } = useSelector((state) => state);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    setOpen(false);
  }, [location]);

  const getMenuMappedList = (menuList) => {
    dispatch(setMenuMappedList(menuList));
  };

  useEffect(() => {
    if (entitlement?.menuList?.main?.length > 0) {
      const membershipMenuList = find(entitlement?.menuList?.main, {
        title: MENU_TITLES.MEMBERSHIP,
      });
      const isRenew = find(membershipMenuList.subLinks, {
        title: MENU_TITLES.RENEW_MEMBERSHIP,
      });
      setIsRenew(isRenew);
    }
  }, [entitlement]);

  useEffect(() => {
    if (isRenew) {
      setCustomMenu((prevItems) => {
        if (prevItems.length === 0) {
          return [...prevItems, printRenewalInvoiceMenu(1)];
        }
        return prevItems;
      });
    }
  }, [isRenew]);

  const mobileMenuHandler = useCallback(() => {
    setOpen(!open);
  }, [open]);

  return (
    <div className="mobile-member-menu-wrapper">
      <div
        className="member-menu-bar"
        role="button"
        onClick={mobileMenuHandler}
      >
        {MENU_TITLES.MEMBERSHIP} <i className="fas fa-bars"></i>
      </div>
      <div className="member-mobile-navigation-container">
        <div
          className={`mobileNavWrapper astm-nav-section bg-primary position-relative offcanvas-overlay ${
            open ? "show" : ""
          }`}
        >
          <div className="container-xl offcanvas-content">
            <NavigationLogo handler={mobileMenuHandler} />
            <div className="nav-container mt-4">
              <div className="main-nav-desktop navbar navbar-expand-md p-0 main-nav navbar-dark astm-navbar ms-auto overflow-auto position-static">
                <ul className="navItemWrapper d-flex navbar-nav m-auto navbar-nav">
                  <MenuItems
                    title={MENU_TITLES.MEMBERSHIP}
                    onClick={() => setActiveMenu(activeMenu === 1 ? 0 : 1)}
                    active={activeMenu === 1}
                  >
                    <LeftMenuLinks
                      customMenu={customMenu}
                      isMemberApp={true}
                      isMainMenu={false}
                      hideUserDetail={true}
                      activePath={history.location.pathname}
                      entitlementList={entitlement.entitlementList}
                      getMenuMappedList={() =>
                        getMenuMappedList(entitlement?.menuList)
                      }
                      userObj={{
                        memberType: get(
                          user.loggedInMemberData,
                          "MembershipTypeId"
                        ),
                      }}
                      globalLinksURL={{
                        profile: process.env.REACT_APP_GLOBAL_PROFILE_URL,
                        membership: PAGE_URL.MYASTM,
                        campus: process.env.REACT_APP_GLOBAL_ASTM_CAMPUS_URL,
                        meetingsSymposia: process.env.REACT_APP_GLOBAL_MEETING_SYMPOSIA_URL,
                        orders: process.env.REACT_APP_GLOBAL_ORDERS_URL,
                        compass: process.env.REACT_APP_GLOBAL_COMPASS_URL,
                        tracker: process.env.REACT_APP_GLOBAL_TRACKERS_URL
                      }}
                    />
                  </MenuItems>
                  {location.pathname.toLowerCase() ===
                    ComponentUrls.MyCommittees.toLowerCase() && (
                    <MenuItems
                      title={MENU_TITLES.MY_TOOLS}
                      onClick={() => setActiveMenu(activeMenu === 2 ? 0 : 2)}
                      active={activeMenu === 2}
                    >
                      {user?.userInfo &&
                        entitlement?.entitlementList?.otherInfo
                          ?.activeMainCommittee.length > 0 && (
                          <MyToolMenu
                            userInfo={user.userInfo}
                            hideHeading={true}
                            memberCommittees={
                              entitlement.entitlementList.otherInfo
                                .activeMainCommittee
                            }
                          />
                        )}
                    </MenuItems>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`offcanvas-backdrop ${open ? "show" : ""}`}></div>
    </div>
  );
};

export default React.memo(MemberMobileMenu);
